import * as React from 'react';
import { storiesOf } from '@storybook/react';
import { Image } from '..';
import { classes } from './Image.visual.st.css';

const tests = [
  {
    describe: 'dimensions',
    its: [
      {
        it: 'fixed width and height',
        props: {
          width: 300,
          height: 200,
        },
      },
      {
        it: 'fixed width',
        props: {
          width: 300,
        },
      },
      {
        it: 'fixed height',
        props: {
          height: 300,
        },
      },
      {
        it: 'fluid',
        props: {
          fluid: true,
        },
      },
    ],
  },
  {
    describe: 'loadingBehavior',
    its: [
      {
        it: 'should blur out to image (sanity)',
        props: {
          loadingBehavior: 'blur',
        },
      },
    ],
  },
  {
    describe: 'aspectRatio',
    its: [
      {
        it: 'square',
        props: {
          aspectRatio: 'square',
        },
      },
      {
        it: 'cinema',
        props: {
          aspectRatio: 'cinema',
        },
      },
      {
        it: 'landscape',
        props: {
          aspectRatio: 'landscape',
        },
      },
      {
        it: 'custom',
        props: {
          aspectRatio: 1.5,
        },
      },
    ],
  },
  // TODO: Flaky tests
  {
    describe: 'resize',
    its: [
      {
        it: 'cover',
        props: {
          resize: 'cover',
          fluid: true,
        },
        containerStyles: {
          width: 500,
          height: 500,
        },
      },
      {
        it: 'contain fluid=false',
        props: {
          resize: 'contain',
        },
        containerStyles: {
          width: 500,
          height: 500,
        },
      },
      {
        it: 'contain',
        props: {
          resize: 'contain',
          fluid: true,
        },
        containerStyles: {
          width: 500,
          height: 500,
        },
      },
    ],
  },
  {
    describe: 'focalPoint',
    its: [
      {
        it: 'bottomCenter',
        props: {
          height: 100,
          focalPoint: 'bottomCenter',
        },
      },
      {
        it: 'topLeft',
        props: {
          height: 100,
          focalPoint: 'topLeft',
        },
      },
      {
        it: 'center',
        props: {
          height: 100,
          focalPoint: 'center',
        },
      },
      {
        it: 'custom',
        props: {
          width: 100,
          focalPoint: { x: 60, y: 0 },
        },
      },
    ],
  },
  {
    describe: 'invalid src',
    its: [
      {
        it: 'should render a placeholder',
        props: {
          src: 'invalid-url.jpg',
        },
      },
    ],
  },
  {
    describe: 'hover',
    its: [
      {
        it: 'should render with zoom on hover',
        props: {
          hoverEffect: 'zoom',
        },
      },
      {
        it: 'should render fluid with zoom on hover',
        props: {
          hoverEffect: 'zoom',
          fluid: true,
        },
      },
    ],
  },
];

const wiringTests = [
  {
    describe: 'Style Overrides',
    its: [
      {
        it: 'borderColor',
        props: {
          className: classes.borderOverride,
        },
      },
      {
        it: 'borderRadius',
        props: {
          className: classes.borderRadiusOverride,
        },
      },
      {
        it: 'opacity',
        props: {
          className: classes.opacityOverride,
        },
      },
      {
        it: 'wst override',
        props: {
          className: classes.wstOverride,
        },
      },
    ],
  },
];

const urls = [
  {
    name: 'Absolute URL',
    src: 'https://upload.wikimedia.org/wikipedia/commons/6/62/Solid_red.svg',
  },
  // TODO - this is flakey
  // {
  //   name: 'Relative Media URI',
  //   src: 'f77a29_e163ea53eab341b48c4edd7049f290f1~mv2.jpg',
  // },
  {
    name: 'Base64 Image',
    src: 'data:image/png;base64,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',
  },
];

urls.forEach(({ name, src }) => {
  [...tests, ...wiringTests].forEach(({ describe, its }) => {
    its.forEach(({ it, props, containerStyles }) => {
      storiesOf(`Image-${name}/${describe}`, module).add(it, () => (
        <div
          style={{
            width: 480,
            height: 360,
            backgroundColor: 'grey',
            ...containerStyles,
          }}
        >
          <Image src={src} resize="cover" width={480} height={360} {...props} />
        </div>
      ));
    });
  });
});
